export default __webpack_public_path__ + "static/favicon-610b0fe43694c167e6f4b7968b1f5930.jpg";